var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	5208: () => (loadSingletonVersion("default", "react", false, [1,18,3,1], () => (__webpack_require__.e(3500).then(() => (() => (__webpack_require__(3500))))))),
	8521: () => (loadStrictVersion("default", "graphql", false, [1,16,12,0], () => (__webpack_require__.e(2435).then(() => (() => (__webpack_require__(2435))))))),
	2702: () => (loadSingletonVersion("default", "react-dom", false, [1,18,3,1], () => (__webpack_require__.e(2337).then(() => (() => (__webpack_require__(2337))))))),
	5899: () => (loadStrictVersion("default", "@hs-baumappe/legacy-ui", false, [1,1,1,14], () => (Promise.all([__webpack_require__.e(1718), __webpack_require__.e(2702), __webpack_require__.e(4532)]).then(() => (() => (__webpack_require__(1718))))))),
	4532: () => (loadStrictVersion("default", "@hs-baumappe/legacy-stylex", false, [1,1,0,3], () => (__webpack_require__.e(159).then(() => (() => (__webpack_require__(159))))))),
	2807: () => (loadStrictVersion("default", "yup", false, [4,0,32,11], () => (__webpack_require__.e(2824).then(() => (() => (__webpack_require__(2824))))))),
	8650: () => (loadStrictVersion("default", "formik", false, [1,2,4,9], () => (__webpack_require__.e(1398).then(() => (() => (__webpack_require__(1398))))))),
	1125: () => (loadStrictVersion("default", "i18next", false, [1,25,7,4], () => (__webpack_require__.e(5413).then(() => (() => (__webpack_require__(5413))))))),
	397: () => (loadStrictVersion("default", "@hs-baumappe/graphql-errors", false, [1,1,5,1], () => (Promise.all([__webpack_require__.e(555), __webpack_require__.e(8521)]).then(() => (() => (__webpack_require__(555))))))),
	5406: () => (loadStrictVersion("default", "react-i18next", false, [1,16,3,1], () => (__webpack_require__.e(4810).then(() => (() => (__webpack_require__(4810))))))),
	1011: () => (loadStrictVersion("default", "react-router-dom", false, [1,6,30,3], () => (Promise.all([__webpack_require__.e(9789), __webpack_require__.e(2702)]).then(() => (() => (__webpack_require__(2170))))))),
	7366: () => (loadStrictVersion("default", "@hs-baumappe/ui", false, [1,14,0,0], () => (Promise.all([__webpack_require__.e(4811), __webpack_require__.e(2702), __webpack_require__.e(7406)]).then(() => (() => (__webpack_require__(4811))))))),
	7406: () => (loadStrictVersion("default", "@hs-baumappe/stylex", false, [1,7,3,2], () => (__webpack_require__.e(3237).then(() => (() => (__webpack_require__(3237))))))),
	585: () => (loadStrictVersion("default", "@apollo/client", false, [1,3,13,8], () => (Promise.all([__webpack_require__.e(9174), __webpack_require__.e(8521)]).then(() => (() => (__webpack_require__(9174))))))),
	629: () => (loadStrictVersion("default", "@hs-baumappe/redkit", false, [1,2,1,2], () => (Promise.all([__webpack_require__.e(1457), __webpack_require__.e(7366)]).then(() => (() => (__webpack_require__(1457))))))),
	3513: () => (loadStrictVersion("default", "@hs-baumappe/frontend-kit", false, [1,3,1,1], () => (__webpack_require__.e(4571).then(() => (() => (__webpack_require__(4571))))))),
	8493: () => (loadStrictVersion("default", "@hs-baumappe/web-auth", false, [1,4,7,0], () => (Promise.all([__webpack_require__.e(2085), __webpack_require__.e(8521)]).then(() => (() => (__webpack_require__(2085))))))),
	8792: () => (loadStrictVersion("default", "date-fns", false, [1,3,6,0], () => (__webpack_require__.e(8885).then(() => (() => (__webpack_require__(8885))))))),
	9427: () => (loadStrictVersion("default", "@hs-baumappe/forms", false, [1,5,2,4], () => (Promise.all([__webpack_require__.e(3305), __webpack_require__.e(2702), __webpack_require__.e(4532), __webpack_require__.e(8650)]).then(() => (() => (__webpack_require__(3305))))))),
	9789: () => (loadStrictVersion("default", "pretty-bytes", false, [1,6,1,1], () => (__webpack_require__.e(5975).then(() => (() => (__webpack_require__(8356))))))),
	2501: () => (loadStrictVersion("default", "launchdarkly-react-client-sdk", false, [1,3,9,0], () => (__webpack_require__.e(4885).then(() => (() => (__webpack_require__(4885))))))),
	3939: () => (loadStrictVersion("default", "@hs-baumappe/pspdfkit", false, [1,1,6,0], () => (__webpack_require__.e(2198).then(() => (() => (__webpack_require__(2198))))))),
	9694: () => (loadStrictVersion("default", "@hs-baumappe/sap-credentials", false, [1,1,0,0], () => (__webpack_require__.e(1709).then(() => (() => (__webpack_require__(4090))))))),
	3835: () => (loadStrictVersion("default", "classnames", false, [1,2,5,1], () => (__webpack_require__.e(8990).then(() => (() => (__webpack_require__(8990)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"682": [
		3835
	],
	"1125": [
		1125
	],
	"2000": [
		585,
		629,
		3513,
		8493,
		8792,
		9427,
		9789
	],
	"2007": [
		2501,
		3939,
		9694
	],
	"2302": [
		397,
		5406,
		1011
	],
	"2702": [
		2702
	],
	"2807": [
		2807
	],
	"4532": [
		4532
	],
	"5208": [
		5208
	],
	"5899": [
		5899
	],
	"7366": [
		7366
	],
	"7406": [
		7406
	],
	"8521": [
		8521
	],
	"8650": [
		8650
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}